import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getLocationList(params) {
  return request({
    url: URL.mdm.city.location,
    method: 'get',
    params
  })
}

export function getLocationsByPlatform(params) {
  return request({
    url: URL.mdm.city.platformLocation,
    method: 'get',
    params
  })
}

export function getAllTemplateLocation(params) {
  return request({
    url: URL.mdm.city.locationTemplate,
    method: 'get',
    params
  })
}

export function saveLocation(data) {
  return request({
    url: URL.mdm.city.location,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addLocationByPlatform(data) {
  return request({
    url: URL.mdm.city.platformLocation,
    method: 'post',
    data
  })
}

export function saveLocations(data) {
  return request({
    url: URL.mdm.city.locations,
    method: 'post',
    data
  })
}

export function delLocation(uuid) {
  return request({
    url: URL.mdm.city.location + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function queryLocations(data) {
  return request({
    url: URL.mdm.city.queryLocations,
    method: 'post',
    data
  })
}
